import { FormikProps, useFormik } from "formik";
import { BankFormProps } from "../types/bank-form";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { RootState } from "store";

const useBankScreen = () => {
  const navigate = useNavigate();
  const bankDetails = useSelector((state: RootState) => state.merchantForm.bankDetails) as any;

  const formik: FormikProps<BankFormProps> = useFormik<BankFormProps>({
    initialValues: {
      accountNumber: bankDetails?.accountNumber || "",
      confirmaccountNumber: bankDetails?.accountNumber || "",
      IFSCcode: bankDetails?.ifsc_info?.IFSC || "",
      accountName: bankDetails?.beneficiary_name || "",
      branchName: bankDetails?.ifsc_info?.BRANCH || "",
      bankName: bankDetails?.ifsc_info?.BANK || ""
    },
    validationSchema: Yup.object({
      accountNumber: Yup.string()
        .required("Account Number is required")
        .matches(/^\d{9,18}$/, "Account Number must be between 9 to 18 digits"),
      confirmaccountNumber: Yup.string()
        .required("Confirm Account Number is required")
        .oneOf([Yup.ref("accountNumber")], "Account Numbers must match"),
      IFSCcode: Yup.string()
        .required("IFSC Code is required")
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code format"),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      navigate("/organisation-business-details");
    },
  });
  return { formik };
};

export default useBankScreen;
